import { Types } from '@store/types';

export const selectTeamMemberById = (data) => {
	return {
		type: Types.SELECT_TEAM_MEMBER,
		payload: data
	};
};

export const selectTeamRequest = (bool) => {
	return {
		type: Types.IS_TEAM_REQUEST_SELECTED,
		payload: bool
	};
};

export const selectMyRequest = (bool) => {
	return {
		type: Types.IS_MY_REQUEST_SELECTED,
		payload: bool
	};
};

export const clearTeamFilter = () => {
	return {
		type: Types.CLEAR_TEAM_FILTER,
		payload: {}
	};
};
